import React, { useContext } from 'react'
import { createPortal } from 'react-dom'
import { CSSTransition } from 'react-transition-group'
import { GlobalContext } from '../../context/GlobalState'
import Loading from '../Loading'
import styles from './Modal.module.css'

const EditListModal = ({ showModal, setShowModal, selectedList, setSelectedList }) => {
  const context = useContext(GlobalContext)

  /* update local state from parent List.js */
  const onChange = e => {
    setSelectedList({...selectedList, [e.target.name]: e.target.value })
  }

  /* update budget checkbox in local state from parent List.js */
  const checkHandler = () => {
    if(selectedList.hasBudget === 'N')
      setSelectedList({...selectedList, hasBudget: 'Y' })
    else 
      setSelectedList({...selectedList, hasBudget: 'N' })
  }

  /* Save updated list via context */
  const onSubmit = async e => {
    e.preventDefault()
    if (selectedList.hasBudget === 'Y' && selectedList.budgetAmt <= 0) {
      context.setError("Budget must be greater than 0")
      context.setStatus('error')
    }
    else {
      context.updateList(selectedList)
      setShowModal(false)
    }
  }

  /* Cancel and close modal */
  const cancel = () => {
    setShowModal(false)
  }

  return showModal ? createPortal
  (
    <CSSTransition
      in={showModal}
      timeout={{ enter: 0, exit: 300 }}
      unmountOnExit
    >
      <div className="modal">
        {context.status === 'pending' ? 
            <Loading /> : (
        <div className="modal-content">
          <div className="modal-header">
            <h4>Edit List</h4>
          </div>
          <form onSubmit={onSubmit}>
            <input
              type="text"
              placeholder="List Name..."
              name="listName" 
              value={selectedList.listName}
              onChange={onChange}>
            </input>

            <div className = "addListDiv">
              <label htmlFor="hasBudget" style={{paddingLeft: '1.8em'}}>Enable budget</label>
              <input 
                type="checkbox"
                name="hasBudget"
                checked={ selectedList.hasBudget === 'Y' ? true : false }
                onChange={checkHandler}>
              </input>
            </div>

            <input
              type="text"
              placeholder="Budget amount..."
              name="budgetAmt" 
              value={selectedList.hasBudget === 'N' ? "N/A" : selectedList.budgetAmt}
              onChange={onChange}
              disabled={selectedList.hasBudget === 'N' ? true : false}>
            </input>

            {context.status === 'error' && <p style={{color:'red'}}>{context.error}</p>}
            <div className={styles.modal_bttn_container}>
              <input type="submit" className={styles.save_bttn} value="Save"></input>
              <input type="button" className={styles.cancel_bttn} value="Cancel" onClick={cancel}></input>
            </div>
          </form>
        </div>
        )}
      </div>
    </CSSTransition>,
    document.body
  )
  : null
}

export default EditListModal